<template>
  <v-container fill-height>
    <v-row>
      <v-col sm="8" md="6" lg="4" offset-sm="2" offset-md="3" offset-lg="4">
        <h1 class="text-center display-1">Login</h1>
        <v-form ref="form" @submit.prevent="submitLogin">
          <v-text-field label="Benutzername" append-icon="mdi-account" v-model="username" :rules="[rules.required]"></v-text-field>
          <v-text-field type="password" label="Password" append-icon="mdi-key" v-model="password" :rules="[rules.required]"></v-text-field>
          <v-btn type="submit" color="primary" class="d-block mx-auto" :loading="loading">Einloggen</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    username: "",
    password: "",
    rules: {
      required: v => !!v || "Bitte ausfüllen"
    }
  }),
  methods: {
    async submitLogin() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        await this.$store.dispatch("login", {
          username: this.username,
          password: this.password
        });
        this.$router.push({ name: "home" });
      } catch (e) {
        alert("Fehler beim Anmelden: " + e.message);
      }

      this.loading = false;
    }
  }
};
</script>

<style>
</style>